export const Validation = {
    phoneNumber: /^(?:^0[0-57-9][0-9]{2}[-\s]?[0-9]{6}$)|(?:^0[0-57-9][0-9][-\s]?[0-9]{7}$)|(?:^06[-\s]?[0-9]{8}$)$/,
    fullName: /^[a-zA-Z]+(?:\s[a-zA-Z]+)+$/,
    zipCode: /^[1-9][0-9]{3}[\s]?[A-Za-z]{2}$/,
    number: /^\d{1,4}([a-zA-Z]{1,2}\d{1,3}|[a-zA-Z]{1,2}|)$/
}